import { render, staticRenderFns } from "./SimpleOtherOptions.vue?vue&type=template&id=0cc75704"
import script from "./SimpleOtherOptions.vue?vue&type=script&lang=js"
export * from "./SimpleOtherOptions.vue?vue&type=script&lang=js"
import style0 from "./SimpleOtherOptions.vue?vue&type=style&index=0&id=0cc75704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports